import { render, staticRenderFns } from "./CustomInputDateComponent.vue?vue&type=template&id=3c99fe50"
import script from "./CustomInputDateComponent.vue?vue&type=script&lang=js"
export * from "./CustomInputDateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports